<template>
  <div id="app">
    <div class="header">
      <div class="logo_img" @click="logoClick">
        <div style="display: flex; align-items: center; height: 65px">
          <div class="header-logo">
            <img
              id="header-img"
              src="../assets/logo.png"
              style="width: 200px; height: 64px"
            />
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- web端菜单导航 -->
        <el-menu
          v-if="seen"
          :default-active="activeIndex"
          class="el-menu-demo"
          menu-trigger="click"
          text-color="#333"
          style="
            display: flex;
            justify-content: space-between;
            height: 65px;
            border: 0;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            width: 100%;
          "
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1" class="header-title">首页</el-menu-item>
          <el-menu-item index="2" class="header-title">企业入驻</el-menu-item>

          <el-menu-item index="3" class="header-title">政策扶持</el-menu-item>
          <el-menu-item index="4" class="header-title">园区简介</el-menu-item>
          <el-menu-item index="5" class="header-title">园区动态</el-menu-item>
          <el-menu-item index="6" class="header-title">联系我们</el-menu-item>
        </el-menu>
        <el-menu
          v-if="!seen"
          :default-active="$route.path"
          class="el-menu-demo"
          menu-trigger="click"
          text-color="#333"
          style="height: 65px; border: 0"
          mode="horizontal"
          @select="handleSelectMobile"
        >
          <el-submenu index="1" class="header-title mobile_menu">
            <template slot="title">{{ currentMenu }}</template>
            <el-menu-item index="1" class="header-title">首页</el-menu-item>
            <el-menu-item index="2-2" class="header-title"
              >生鲜果蔬</el-menu-item
            >
            <el-menu-item index="2-1" class="header-title"
              >产品微观</el-menu-item
            >
            <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
            <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
            <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div v-if="seen">
        <el-button
          type="primary"
          style="
            background: #ffffff;
            border: 1px solid #bd1a2d;
            border-radius: 15px;
            color: #bd1a2d;
            padding: 7px 21px;
            font-size: 16px;
          "
          class="header-title"
          @click="login"
          round
          >登录</el-button
        >
        <!-- <el-button type="primary" class="header-title" @click="register" round
          >注册</el-button
        > -->
      </div>
    </div>
    <div style="height: 123px"></div>
    <div class="img">
      <img src="../assets/index.png" style="width: 100%; height: auto" />
    </div>
    <div class="container" style="clear: both; margin: 0 auto">
      <router-view :activeIndex="activeIndex"></router-view>
    </div>
    <div class="bottom">
      <div class="left">
        <div>
          <img src="../assets/home/phone.png" />
          <span
            style="
              font-size: 42px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
              margin-left: 20px;
            "
            >0371-55238625</span
          >
        </div>
        <div
          style="
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            margin-top: 21px;
            margin-bottom: 27px;
          "
        >
          地址：河南省济源市高新区科教街涌盛产业园双子楼A/B座
        </div>
        <div
          style="
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            display: flex;
            margin-bottom: 30px;
          "
        >
          <span
            style="margin-right: 23px; cursor: pointer"
            @click="navClick(settlesI)"
            >企业入驻</span
          >
          <div
            v-for="(i, index) in navData"
            :key="index"
            style="padding: 0 23px; border-left: 1px solid #fff"
          >
            <span style="color: #ffffff; cursor: pointer" @click="navClick(i)">
              {{ i.title }}</span
            >
          </div>
        </div>
        <div
          style="
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 26px;
          "
        >
          友情链接:<span
            style="margin: 0 20px; color: #ffffff"
            v-for="(i, index) in linkData"
            :key="index"
          >
            <a :href="i.connect" style="color: #ffffff">{{ i.title }}</a>
          </span>
        </div>
        <div
          style="
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            display: flex;
            width: 100%;
          "
        >
          <div style="display: flex">
            <div style="margin-top: 3px; margin-right: 3px">
              <img
                src="../assets/gonAn.png"
                alt=""
                style="width: 16px; height: 17px"
              />
            </div>
            <div>
              <a
                rel="noreferrer"
                href="https://beian.mps.gov.cn/#/query/webSearch?code=41900102411057"
                target="_blank"
                style="color: #fff !important"
                >&nbsp;豫公网安备41900102411057号
              </a>
            </div>
          </div>
          <div>
            <a class="beianLink" href="https://beian.miit.gov.cn"
              >豫ICP备2022018204号</a
            >
            <a class="beianLink">经营许可证编号: 豫B2-20231100</a>
          </div>
        </div>
      </div>
      <div class="ercode">
        <img
          src="../assets/other/ercode.jpg"
          style="
            width: 161px;
            height: 161px;
            background: #ffffff;
            margin-bottom: 23px;
          "
        />
        <div
          style="
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          "
        >
          扫描关注微信公众号
        </div>
      </div>
    </div>
    <div id="back_to_top" ref="btn" @click="backTop" style="display: none">
      <p style="font-size: 0.625em; font-weight: bold">TOP</p>
      <img src="../assets/other/launch.png" style="height: 45px; width: 35px" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      // activeIndex: "1",
      company: {
        qrcode: require("../../static/other/公众号二维码.jpg"),
      },

      scroll: "",
      timer: "",
      seen: true,
      currentMenu: "首页",
      screenHeight: "",
      settlesI: {
        title: "企业入驻",
        name: "businessSettled",
        index: "2",
      },
      navList: [
        { name: "Index", title: "首页" },
        { name: "businessSettled", title: "企业入驻" },
        { name: "policySupport", title: "政策扶持" },
        { name: "park", title: "园区简介" },
        { name: "parkState", title: "园区动态" },
        { name: "contact", title: "联系我们" },
      ],
      navData: [
        {
          title: "政策扶持",
          name: "policySupport",
          index: "3",
        },
        {
          title: "园区简介",
          name: "park",
          index: "4",
        },
        {
          title: "园区动态",
          name: "parkState",
          index: "5",
        },
        {
          title: "联系我们",
          name: "contact",
          index: "6",
        },
      ],
      linkData: [
        {
          title: "济源市政府网",
          connect: "http://m.jiyuan.gov.cn/",
        },
        {
          title: "王屋镇政府网",
          connect: "http://xxgk.www.jiyuan.gov.cn/wangwuz/15889/15900/",
        },
        {
          title: "河南日报社",
          connect: "https://www.hnby.com.cn/",
        },
        {
          title: "大河好运",
          connect: "http://www.dahehuoyun.com/",
        },
      ],
    };
  },
  // watch(){
  //     screenHeight

  // },

  computed: {
    activeIndex() {
      const route = this.$route;
      const { meta, path } = route;
      console.log("activeMenu", meta, path);
      // if set path, the sidebar will highlight the path you set
      if (path == "/businessSettled") {
        this.currentMenu = "企业入驻";
        return "2";
      } else if (path == "/policySupport") {
        return "3";
      } else if (path == "/park") {
        return "4";
      } else if (path == "/parkState") {
        return "5";
      } else if (path == "/contact") {
        return "6";
      } else {
        return "1";
      }
    },
  },
  methods: {
    navClick(i) {
      this.$router.push({
        name: i.name,
      });
      this.currentMenu = i.title;
      this.activeIndex = i.index;
    },
    handleSelect(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          break;
        case "2":
          this.$router.push({ name: "businessSettled" });
          break;

        case "3":
          this.$router.push({ name: "policySupport" });

          break;
        case "4":
          this.$router.push({ name: "park" });

          break;
        case "5":
          this.$router.push({ name: "parkState" });

          break;
        case "6":
          this.$router.push({ name: "contact" });
          break;
      }
    },
    handleSelectMobile(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          this.currentMenu = "首页";
          break;
        case "2":
          this.$router.push({ name: "businessSettled" });

          this.currentMenu = "企业入驻";
          break;

        case "3":
          this.$router.push({ name: "policySupport" });
          this.currentMenu = "政策扶持";
          break;
        case "4":
          this.$router.push({ name: "park" });

          this.currentMenu = "园区简介";
          break;
        case "5":
          this.$router.push({ name: "parkState" });

          this.currentMenu = "园区动态";
          break;
        case "6":
          this.$router.push({ name: "contact" });

          this.currentMenu = "联系我们";
          break;
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) {
        //判断滚动后高度超过400px,就显示
        this.$refs.btn.style.display = "block";
      } else {
        this.$refs.btn.style.display = "none";
      }
    },
    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },
    login() {
      window.open("https://admin.kehui99.cn/login?redirect=%2Findex");
    },
    register() {
      window.open("https://admin.fastice-tech.com/registe");
    },
    menuSeen() {
      // 屏幕尺寸
      this.screenHeight = document.body.clientWidth;

      console.log(" menuSeen", this.screenHeight, document.body.clientWidth);
      if (this.screenHeightt > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = "首页";
    },
  },
  mounted() {
    // this.menuSeen()
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="less">
#app {
  width: 100%;
}
.bottom {
  height: 326px;
  padding: 5% 18% 5% 18%;
  background: #d7000f;
  display: flex;
  justify-content: space-between;
}
.el-menu-item {
  padding: 0;
  margin-right: 31px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #e60e0e;
  color: #e60e0e;
}
.logo_img {
  // float: left;
  width: 250px;
  cursor: pointer;
}
#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
}
.header-title {
  font-size: 1em;
}
.company_name {
  font-weight: normal;
  font-size: 1em;
}
.footer_font {
  font-size: 1em;
}
#menu_index {
  // float: left;
  width: 50%;
  //   height: 100%;
  line-height: 123px;
}
.header {
  width: 100%;
  position: fixed;
  top: 0;
  padding-left: 15%;
  z-index: 999999;
  height: 123px;
  display: flex;
  align-items: center;
  background-color: white;
  /* position: fixed; */
  /*background: #F56C6C;*/
}
.beianLink {
  color: white;
  margin-left: 20px;
}
@media screen and (max-device-width: 415px) {
  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }
  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 5px;
    cursor: pointer;
  }
  .footer_font {
    font-size: 0.875em;
  }
  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }
  .mobile_menu {
  }
}
#header-img {
  width: 50px;
  height: 50px;
  float: left;
  margin: auto;
}
.header-logo {
  height: 50px;
  width: 50px;
  align-self: center;
}
.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 90%;
}
a {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
a:active {
  text-decoration: none;
}
</style>